import { ImageLoader } from 'next/image'

/**
 * Uses the storyblok image service to optimize images
 * https://www.storyblok.com/docs/image-service/
 */
export const storyblokImageLoader: ImageLoader = ({ src, width }) => {
  return `${src}/m/${width}x0/`
}
